import HeaderBar from "../../../Components/UI/headerbar";
import RolesTab from "../../systemsettings/roles";

const RolesPage = () => {
  return (
    <div>
      <HeaderBar
        title={" الأدوار و الصلاحيات "}
        content={"إدارة الأدوار و الصلاحيات"}
      />

      <RolesTab />
    </div>
  );
};

export default RolesPage;
